<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title">
      <app-page-cardhead style="margin-top: -1.1rem" [PageName]="reportTitle" [PageHeadWidth]="600"></app-page-cardhead>
    </div>
    <button class="btn btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="modal-body p-0">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ reportTitle }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">Loan Number</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">ID Number</th>
                <th scope="col">Status</th>
                <th scope="col">Mandate Reference</th>
                <th scope="col">Branch Name</th>
                <th scope="col">Branch Serial</th>
                <th scope="col">Area Name</th>
                <th scope="col">Loan Reference</th>
                <th scope="col">Created By</th>
                <th scope="col">Created On</th>
                <th scope="col">Updated By</th>
                <th scope="col">Updated On</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of nupayReportList | paginate: config">
                <td>{{ row.id }}</td>
                <td>{{ row.firstName }}</td>
                <td>{{ row.lastName }}</td>
                <td>{{ row.idNumber }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.mandateReference }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.branchSerial }}</td>
                <td>{{ row.areaName }}</td>
                <td>{{ row.loanReference }}</td>
                <td>{{ row.createdBy }}</td>
                <td>{{ row.createdOn }}</td>
                <td>{{ row.updatedBy }}</td>
                <td>{{ row.updatedOn }}</td>
              </tr>
              <tr *ngIf="nupayReportList.length === 0">
                <td colspan="8" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'nupay-report-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

      <div class="action-bar">
        <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
          <i class="fas fa-file-excel fa-fw"></i> Export to Excel
        </button>
        <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
      </div>

    </section>
  </div>
</div>
